module.exports = __webpack_public_path__ + "img/mentors.f7cf4e7f.webp";